export default {
    All: 1,
    OnlyOpening:2,
    OnlyVoucher: 3
}